export default () => ({
  componentName: 'cell-seller-status',
});
